import WalledContent from 'components/Common/WalledContent'
import * as React from 'react'
import { useIntl } from 'react-intl'
import SearchTilePrimaryActionButton from '../shared/SearchTilePrimaryActionButton'
import SearchTileSignUpButton from '../shared/SearchTileSignUpButton'
import TextButton from 'LuxKit/Button/TextButton'
import useHideAnytimePrices from '../../../../hooks/Offers/useHideAnytimePrices'
import { getAccommodationSearchPrimaryAction } from 'lib/search/accommodationSearchPresentation'

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary
  offerMetaData?: App.OfferListMetaData
  onSelectDatesClick?: () => void
  filters?: App.OfferListFilters
  productType?: App.ProductType
  hideMemberWalls?: boolean
}

function HotelSearchTileAction({ offer, offerMetaData, onSelectDatesClick, filters, productType, hideMemberWalls = false }: Props) {
  const intl = useIntl()
  const hidePrice = useHideAnytimePrices(offer.type, !!offerMetaData?.hidePricing, productType ?? offer.productType, filters)
  const primaryAction = getAccommodationSearchPrimaryAction({
    offerType: offer.type,
    hidePrice,
    isAnytimeSearch: !filters?.checkIn && !filters?.checkOut && !filters?.flexibleNights,
    canSelectDates: !!onSelectDatesClick,
  })

  const handleSelectDatesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (primaryAction === 'select-dates' && onSelectDatesClick) {
      e.preventDefault()
      onSelectDatesClick()
    }
  }

  const actionButton = primaryAction === 'select-dates' ? (
    <TextButton nonInteractable kind="primary" onClick={handleSelectDatesClick}>
      {intl.formatMessage({
        id: 'mYW_5ONvelTb6ekAT5XM',
        defaultMessage: 'Select dates',
        description: 'Button text prompting user to select dates on hotel search tile',
      })}
    </TextButton>
  ) : (
    <SearchTilePrimaryActionButton />
  )

  return <WalledContent
    enforced={!hideMemberWalls && offer.walledGarden}
    wall={<SearchTileSignUpButton />}
  >
    {!offerMetaData?.extendedAvailability && actionButton}
  </WalledContent>
}

export default HotelSearchTileAction
